<template>
    <div class="ccpay-supmetdetail">
         <div class="ccpay-supmetdetail-header">
                <span @click="back"> 退後</span>
                <span >補充</span>
                <span></span>
         </div>
         <div class="ccpay-supmetdetail-connect">
            <ul style="background:white">
                <li class="ccpay-supmetdetail-type">
                    <span style="margin-left: 0.5rem;font-size: 16px;">类型：</span>
                    <select name="selected" id="" v-model="selected" @change="getTypeSelected">
                             <option :value="types.name" v-for="(types,index) in typeList" :key="index">{{types.name}}</option>  
                     </select>

                    <!-- <select>
                         <option>DEPOSIT</option>
                         <option>WITHDRAW</option>
                         <option>HEDGING</option>
                    </select> -->
                  <!-- <mt-field class="phoneNum phoneNumTull-lv"  
                   placeholder="类型" 
                    v-model="type"
                    ></mt-field> -->
                </li>
                 <li class="ccpay-supmetdetail-type">
                  <input class="phoneNum phoneNumTull-lv app-Recharge-number" v-model="price" v-on:input="blurbumber"   placeholder="均价" type="number" 
                 ></input>
                <!--  <mt-field class="phoneNum phoneNumTull-lv"  
                   placeholder="均价" 
                   v-on:input="blur" 
                    v-model="price"
                    ></mt-field>-->
                </li>
                 <li class="ccpay-supmetdetail-type">
                 <input class="phoneNum phoneNumTull-lv app-Recharge-number" v-model="fee" v-on:input="blurfee"  placeholder="手续费" type="number" 
                 ></input>
                 <!--  <mt-field class="phoneNum phoneNumTull-lv"  
                   placeholder="手续费" 
                    v-model="fee"
                    ></mt-field>-->
                </li>
                  <!-- <li>
                  <mt-field class="phoneNum phoneNumTull-lv sup-tec"  
                   placeholder="截图" 
                    v-model="name"
                    ></mt-field>
                </li> -->
                <li>
                    <div class="ccpay-add-img">
                        <p class="sup-tec" style="font-size: 16px;">截图</p>
                        <CloudflareR2Upload
                            :folderPrefix="'fund/supplement/'"
                            :acceptTypes="'*.png;*.jpeg;*.jpg;*.gif'"
                            :maxFileSize="5000"
                            @upload-start="handleUploadStart"
                            @upload-success="handleUploadSuccess"
                            @upload-error="handleUploadError"
                            @upload-remove="handleUploadRemove"
                        />
                    </div>
                </li> 
               
                 <li>
                  <mt-field class="phoneNum phoneNumTull-lv"  
                   placeholder="备注" 
                    v-model="remark"
                    ></mt-field>
                </li>
           
              <li >
                    <mt-button class="mt-40" size="large" type="primary" 
                        @click="submit()">補充</mt-button>
                </li>
                 </ul>
         </div>
    </div>
</template>

<script>
import { Indicator } from 'mint-ui';
import moment from "moment"
import CloudflareR2Upload from '../CloudflareR2Upload.vue'
export default {
    components: {
        CloudflareR2Upload
    },
    data(){
        return {
            fund_id:'',//id
            type:'',//类型
            price:'',//均价
            fee:'',//费率
            remark:'',//補充
            typeList:[
                {id:1,name:'对冲'},
                {id:2,name:'借调'},
                {id:3,name:'出入金'},
            ],
            selected:'',
            uploadedFileUrl:'' // 存储上传成功的文件URL
        }
    },
    mounted(){  
        this.fund_id= this.$route.query.fund_id
        this.selected = this.typeList[0].name;
        console.log()
    },
    
    methods:{
        moment,
        getTypeSelected(){
            // this.selected = this.selected
            // console.log(this.selected)
        },
        blurbumber(){
            if(this.price==''){
                this.price = ''
                return
            }
             if(this.price<=0){
                this.price = 0
            }
            let a= this.price.toString().match(/^\d+(?:\.\d{0,2})?/)[0]
             this.price =  a
            //  console.log(this.price)
        },
        blurfee(){
            if(this.fee==''){
                this.fee = ''
                return
            }
             if(this.fee<=0){
                this.fee = 0
            }
             let a= this.fee.toString().match(/^\d+(?:\.\d{0,2})?/)[0]
             this.fee =  a
            //  console.log(this.fee)
        },
        back(){
            this.$router.go(-1)
        },
        submit(){
           
            if(this.price==''){
                this.$Toast('请输入均价')
                return
            }
            if(this.fee==''){
                this.$Toast('请输入手续费')
                return
            }
            if(this.remark==''){
                this.$Toast('请填写备注')
                return
            }
            if(this.uploadedFileUrl==''){
                this.otosubmit()
            }else{
                this.otosubmit()
            }
           
        },
        otosubmit(){
            Indicator.open();
            this.$axios.post('/v1/traders_profit/fund_ex_info/append',{
                "fund_id": this.fund_id,
                "type": this.selected,
                "price": this.price,
                "fee": this.fee,
                "img": this.uploadedFileUrl,
                "remark": this.remark
            }).then(res=>{
                 Indicator.close();
                if(res.code==0){
                    this.$router.go(-1)
                     this.$Toast(res.msg)
                }else{
                     this.$Toast(res.msg)
                }
            })
        },
        // 新组件事件处理方法
        handleUploadStart() {
            console.log('开始上传文件...')
        },
        
        handleUploadSuccess(fileUrl) {
            this.uploadedFileUrl = fileUrl
            this.$Toast('文件上传成功')
            console.log('文件上传成功:', fileUrl)
        },
        
        handleUploadError(error) {
            this.$Toast('文件上传失败: ' + error.message)
            console.error('文件上传失败:', error)
        },
        
        handleUploadRemove() {
            this.uploadedFileUrl = ''
            console.log('文件已删除')
        },
    }
}
</script>

<style lang="scss" scoped>
    .ccpay-supmetdetail{
        .ccpay-supmetdetail-type{
            position: relative;
             padding:0 10px;
            color: #666;
            font-size: 0.93rem;
            border-bottom: 1px solid;
            border-color: #eee;
            // height: 3re;
            background: white;
            height: 3rem;
            line-height: 3rem;
            select{
                    height:30px;
                    border:none;
                    background: white;
                    width: 50%;
                    outline: none;
                    option{
                        // height: 2rem;;
                        // line-height: 4rem;
                    }
            }
        }
        .sup-tec{
             color: #888;
            text-align: center;
            line-height: 3rem;
        }
         height: 100%;
         background: #f8f8f8;
         .ccpay-supmetdetail-header{ 
                height: 3rem;
                line-height: 3rem;
                width: 100%;
                position: fixed;
                background: white;
                display: flex;
                justify-content: space-between;
                span:nth-of-type(1){
                    margin-left: 1rem
                }
                span:nth-of-type(3){
                    margin-right: 1rem
                }
         }
         .ccpay-supmetdetail-connect{
              padding-top: 4rem;
             padding-left:1rem;
             padding-right:1rem;
         }
         .ccpay-add-img{
        margin-bottom: 2rem;
        text-align: center;
    }
    .ccpay-resadd-img{
        margin-bottom: 1rem;
        display: flex;
        justify-content: center;
        button{
             background: #ccc;
            padding: 6px;
            outline: none;
            border: none;
            color: white;
        }
    }
    .app-Recharge-number{
            font-size: 16px;
            font-weight: 400 !important;
            font-family: inherit;
            line-height: 2.3rem !important;
            outline: none;
            padding: 0 10px;
            // margin-left: 0.4rem !important;
            width: 95%;
                border: none;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/my/supmetdetail.vue